import { CircularProgress } from '@mui/material'
import { Modal } from 'react-bootstrap'
import { createPortal } from 'react-dom'
import React, { useState } from 'react'
import TransactionDetailComponent from './TransactionDetailComponent'

const modalsRoot = document.getElementById('root-modals') || document.body

const TransactionDetails = ({ show, handleClose, payment }: any) => {
    const [transactionDetailsFor, setTransactionDetailsFor] = useState(payment.tenant_rent_status_name.toLowerCase() === "completed" ? "rent" : "utility")
    return createPortal(
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
            show={show ? true : false}
            onHide={handleClose}
            backdrop={true}
        >
            {/* Begin: Modal header */}
            <div className='modal-header pt-5 pb-5'
            // ref={modalHeaderRef}
            >
                {/* Begin: Modal Heading */}
                <h2>Transaction Details</h2>
                {/* End: Modal Heading */}
                {/* Begin::Close button */}
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                    <i className='bi bi-x-lg' onClick={handleClose}></i>
                </div>
                {/* end::Close button */}
            </div>
            {/* End: Modal header */}

            {/* Begin: Modal body */}
            <div className='modal-body p-0'>
                <div className='card-body p-9 pt-5 row justify-content-between'>
                    {/* <div className='col-6 row'> */}
                    {/* <h4 className='text-center page-heading text-primary fw-bold fs-4 mb-4'>Property Details</h4> */}
                    <div className='row mb-6 col-6'>
                        <label className='col-lg-6 fw-bold text-muted'>Property Name</label>
                        <div className='col-lg-6'>
                            <span className='fw-bold fs-6 pb-1'>
                                {/* {PANGSTCINNumber.pan ? PANGSTCINNumber.pan : "-"} */}
                                {payment.property_title}
                            </span>
                        </div>
                    </div>

                    {
                        payment.property_unit_name &&
                        <div className='row mb-6 col-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Subdivision name</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {payment.property_unit_name}
                                </span>
                            </div>
                        </div>
                    }

                    {/* <hr /> */}
                    <div className='d-flex overflow-auto h-55px'>
                        <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                            {
                                payment.tenant_rent_status_name.toLowerCase() === "completed" &&
                                <li className='nav-item' >
                                    <span
                                        className={`nav-link text-active-primary me-6 ${transactionDetailsFor === 'rent' && 'active underline'} `}
                                        onClick={() => setTransactionDetailsFor("rent")}
                                    >
                                        Rent Transaction Details
                                    </span>
                                </li>
                            }
                            {
                                payment.tenant_utility_status_name.toLowerCase() === "completed" &&
                                <li className='nav-item' >
                                    <span
                                        className={`nav-link text-active-primary me-6 ${transactionDetailsFor === 'utility' && 'active underline'} `}
                                        onClick={() => setTransactionDetailsFor("utility")}
                                    >
                                        Utility Transaction Details
                                    </span>
                                </li>
                            }
                        </ul>
                    </div>
                    {
                        transactionDetailsFor === "rent" &&
                        <TransactionDetailComponent
                            type={"Rent"}
                            status_name={payment.tenant_rent_status_name}
                            payment_method_name={payment.payment_method_name}
                            payment_reference={payment.payment_reference}
                            receipt_link={payment.receipt_link}
                            proof_of_payment_link={payment.proof_of_payment_link} />
                    }
                    {
                        transactionDetailsFor === "utility" &&
                        <TransactionDetailComponent
                            type={"Utility"}
                            status_name={payment.tenant_utility_status_name}
                            payment_method_name={payment.utility_payment_method_name}
                            payment_reference={payment.utility_payment_reference}
                            receipt_link={payment.utility_receipt_link}
                            proof_of_payment_link={payment.utilty_proof_of_payment_link} />
                    }
                </div>
            </div>
        </Modal >,
        modalsRoot
    )
}

export default TransactionDetails